


































import BaseComponent from '@/components/base-component.vue';
import { getTemplatePreview } from '@/services/prescription-templates';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as resize from '@/subjects/resize';
import FadeTwin from '@/components/UI/fade-twin.vue';

@Component({
  components: { FadeTwin },
  directives: {}
})
export default class PatternPreviewMenu extends BaseComponent {
  @Prop()
  public id;

  @Prop()
  public activator;

  @Prop()
  public menuX;

  @Prop()
  public menuY;

  showMenu = false;

  dto = null;
  key = 0;
  smallScreen: boolean = resize.isXsOrSmSizeScreen();

  public $refs!: {
    form: HTMLFormElement;
  };

  loading = false;
  error = false;
  items = null;

  mounted() {}

  @Watch('id', { immediate: true })
  onIdChange(id) {
    if (!id) {
      return;
    }
    this.loadPreview();
    setTimeout(() => {
      this.showMenu = true;
    }, 100);
  }

  loadPreview() {
    if (!this.id) {
      this.showMenu = false;
      return;
    }
    this.loading = true;
    this.showMenu = true;
    getTemplatePreview(this.id).subscribe(
      (res) => {
        this.dto = res;
        this.loading = false;
        this.key++;
      },
      (error) => {
        this.showToastApiError(error);
        this.loading = false;
      }
    );
  }

  @Watch('showMenu')
  onShowMenuChange(sm) {
    if (!sm) {
      this.$emit('close');
    }
  }

  close() {
    this.showMenu = false;
  }
}
